<template>
  <div id="headersFornedores">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          sm="3"
          md="3"
          lg="3"
        >
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Produtos
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in produtoSegmento"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    class="text-left"
                    :style="{ backgroundColor: textoFiltro === item.produto ? 'yellow' : '' }"
                    @click="tabelaVendaSemMovimento(item.produto)"
                  >
                    {{ item.produto }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <v-col
          v-if="venda"
          cols="12"
          sm="9"
          md="9"
          lg="9"
        >
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Quantidade de Clientes Faturados
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Faturamento
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                  >
                    Média Faturamento
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in dadosClientesFaturados"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.faturamento }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.media }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <div
            v-if="loading1"
            :style="styleObject"
            class="text-center"
          >
            <v-icon
              light
              class="custom-loader"
              :style="styleObject"
            >
              mdi-cached
            </v-icon>
            Carregando dados...
          </div>
          <div
            v-else-if="error1"
            class="alert alert-danger"
          >
            {{ error1 }}
          </div>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <span>Quantidade de Clientes: {{ totalClientes }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
            >
              <v-btn
                id="btnPrintExcel"
                class="col-6"
                small
                dark
                :disabled="enableBtn"
                :color="corPrimaria"
                :loading="imprimindo"
                @click="exportExcel()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta Excel
                <template v-slot:loader>
                  <span>Gerando...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center; cursor: pointer;"
                    @click="ordenarPor('cliente')"
                  >
                    Clientes Não Compraram
                    <span v-if="colunaOrdenada === 'cliente'">{{ ordemCrescente ? '▲' : '▼' }}</span>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center; cursor: pointer;"
                    @click="ordenarPor('vendedor')"
                  >
                    Vendedor Responsável
                    <span v-if="colunaOrdenada === 'vendedor'">{{ ordemCrescente ? '▲' : '▼' }}</span>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center; cursor: pointer;"
                    @click="ordenarPor('faturamento')"
                  >
                    Faturamento
                    <span v-if="colunaOrdenada === 'faturamento'">{{ ordemCrescente ? '▲' : '▼' }}</span>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center; cursor: pointer;"
                    @click="ordenarPor('area')"
                  >
                    Área Comercial
                    <span v-if="colunaOrdenada === 'area'">{{ ordemCrescente ? '▲' : '▼' }}</span>
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in dadosOrdenados"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.vendedor }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ getCurrency(item.faturamento) }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.area }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import MixCliente from '../../../../../services/mixcliente2'
  import eventEmit from '../../core/EventoEmit'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowMixCliente',
    emits: ['setDadosPrintMixCliente'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleSlider: {
        color: '#000000',
      },
      corPrimaria: '#2863af',
      value: 0,
      enableBtn: true,
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      vendedores: [],
      receita: [],
      areas: [],
      segmento: [],
      classificacao: [],
      headersProduto: [
        { text: 'Produtos', value: 'produto', width: '200px', align: 'left', class: 'black--text title' },
      ],
      headersVenda: [
        { text: 'Quantidade de Clientes Faturados', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Média Faturamento', value: 'media', align: 'right', class: 'black--text title' },
      ],
      headersSemMovimento: [
        { text: 'Clientes Não Compraram', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor Responsável', value: 'vendedor', align: 'lef', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Área Comercial', value: 'area', align: 'left', class: 'black--text title' },
      ],
      dadosClientesFaturados: [],
      dadosFaturamento: [],
      dadosSemMovimento: [],
      produtoSegmento: [],
      produtoSelect: [],
      textoFiltro: '',
      textoClick: '',
      venda: false,
      semMovimento: false,
      clienteIds: [],
      dadosAux: [],
      sortBy: '',
      sortDesc: false,
      totalClientes: 0,
      imprimindo: false,
      dadosSemMovimentoExcel: [],
      colunaOrdenada: '',
      ordemCrescente: true,
    }),

    computed: {
      dadosOrdenados () {
        return [...this.dadosSemMovimento].sort((a, b) => {
          const col = this.colunaOrdenada
          if (!col) return 0

          const valA = a[col] ?? ''
          const valB = b[col] ?? ''

          // Tratamento especial para 'faturamento' que pode ser monetário
          if (col === 'faturamento') {
            const numA = parseFloat(valA.toString().replace(/[^\d,.-]/g, '').replace(',', '.')) || 0

            const numB = parseFloat(valB.toString().replace(/[^\d,.-]/g, '').replace(',', '.')) || 0

            return this.ordemCrescente ? numA - numB : numB - numA
          }

          // Comparação padrão de texto
          if (valA < valB) return this.ordemCrescente ? -1 : 1

          if (valA > valB) return this.ordemCrescente ? 1 : -1

          return 0
        })
      },
    },

    created () {
      eventEmit.$on('update-mix-cliente-2', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-mix-cliente-2', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, receita, segmento, classificacao) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.vendedores = vendedorSelect
        this.redes = redeSelect
        this.receita = receita
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.segmento = segmento
        this.classificacao = classificacao

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true
        this.dadosFaturamento = []

        this.venda = false
        this.semMovimento = false
        this.textoClick = ''
        this.textoFiltro = ''

        this.produtoSegmento = []
        this.dadosFaturamento = []

        await MixCliente.showDadosProdutos(this.dataInicial, this.dataFinal, this.empresaSelect, this.vendedores, this.redes, localStorage.tokencontrato, this.receita, this.cidades, this.areas, this.segmento, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.produtoSegmento = resposta.data.dadosProdutos.map((item) => {
              var listaProdutos = ({
                produto: item,
              })

              return listaProdutos
            })

            this.dadosFaturamento = resposta.data.dadosVenda.map((item) => {
              var listaFaturamento = ({
                produto: item.produto,
                cliente: item.cliente,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                media: item.media.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                agrupado: this.dadosAgrupados(item.agrupado),
              })

              return listaFaturamento
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosAgrupados (value) {
        const agrupado = value.map((item) => {
          var listaAgrupado = ({
            cliente: item.cliente,
            idCliente: item.idCliente,
            nomeBd: item.nomeBd,
          })

          return listaAgrupado
        })

        return agrupado
      },

      tabelaVendaItem (value) {
        this.venda = true
        this.semMovimento = false
        this.textoFiltro = value

        this.dadosClientesFaturados = []

        this.dadosClientesFaturados = this.dadosFaturamento.filter(dado => dado.produto === value)
      },

      tabelaVendaSemMovimento (value) {
        this.tabelaVendaItem(value)

        this.loading1 = true
        this.venda = true
        this.semMovimento = true
        this.textoClick = value

        this.dadosAux = []

        this.dadosAux = this.dadosFaturamento.filter(dado => dado.produto === value)

        var i = 0

        this.clienteIds = []

        for (i in this.dadosAux[0].agrupado) {
          this.clienteIds.push(this.dadosAux[0].agrupado[i])
        }

        this.dadosSemMovimento = []
        this.totalClientes = 0

        this.enableBtn = true

        MixCliente.showDadosClientesSemMovimentacao(this.dataInicial, this.dataFinal, this.empresaSelect, this.vendedores, this.redes, this.clienteIds, value, localStorage.tokencontrato, this.receita, this.cidades, this.areas, this.segmento, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosSemMovimento = resposta.data.dadosExibicao.map((item) => {
              var lista = ({
                cliente: item.cliente,
                vendedor: item.vendedor ? item.vendedor : '-',
                faturamento: item.faturamento,
                area: item.area ? item.area : '-',
              })

              return lista
            })

            this.totalClientes = this.dadosSemMovimento.length

            this.dadosSemMovimentoExcel = this.dadosSemMovimento

            eventEmit.$emit('set-dados-print-mix-cliente', value, this.dadosSemMovimento, this.dadosClientesFaturados, this.totalClientes)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading1 = false })
      },

      getCurrency (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      ordenarPor (coluna) {
        if (this.colunaOrdenada === coluna) {
          this.ordemCrescente = !this.ordemCrescente
        } else {
          this.colunaOrdenada = coluna
          this.ordemCrescente = true
        }
      },

      mudarOrdenacao (options) {
        this.sortBy = options.sortBy[0]
        this.sortDesc = options.sortDesc[0]

        this.buscarDados()
      },

      buscarDados () {
        const novaOrdenacao = [...this.dadosSemMovimento]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.sortBy] < b[this.sortBy]) result = -1

          if (a[this.sortBy] > b[this.sortBy]) result = 1

          if (this.sortDesc) result *= -1

          return result
        })

        this.dadosSemMovimentoExcel = novaOrdenacao

        eventEmit.$emit('set-dados-print-mix-cliente', this.textoClick, novaOrdenacao, this.dadosClientesFaturados, this.totalClientes)
      },

      async exportExcel () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Mix Cliente')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:D${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect.map(e => e.empresaSelect))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

            posY += 1

            // Adicionar Produto Selcionado
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Produto Selecionado: ' + this.textoClick
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
            posY += 2

            // Adicionar dados clientes faturados
            worksheet.getCell(`A${posY}`).value = 'Quantidade Clientes Faturados: ' + this.dadosFaturamento[0].cliente
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
            worksheet.mergeCells(`B${posY}:C${posY}`)
            worksheet.getCell(`B${posY}`).value = 'Faturamento: ' + this.dadosFaturamento[0].faturamento
            worksheet.getCell(`B${posY}`).font = { size: 10 }
            worksheet.getCell(`B${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
            worksheet.getCell(`D${posY}`).value = 'Média Faturamento: ' + this.dadosFaturamento[0].media
            worksheet.getCell(`D${posY}`).font = { size: 10 }
            worksheet.getCell(`D${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            // Adicionar quantidade clientes
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Quantidade de Clientes: ' + this.totalClientes
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 1
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2 // +2 para dar um pequeno espaçamento
            })
          }

          inserirTitulo(worksheet)

          // Adiciona tabela de dados
          const tableHeaders = this.headersSemMovimento.map(header => header.text)
          const tableData = this.dadosSemMovimentoExcel.map(item => [
            item.cliente,
            item.vendedor,
            item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            item.area,
          ])

          worksheet.addRow(tableHeaders).font = { bold: true }
          tableData.forEach(row => worksheet.addRow(row))
          posY += tableData.length + 1

          ajustarLarguraColunas(worksheet, tableHeaders, tableData)

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_mix_cliente.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
      /* margin: 0 0 0 -1rem; */
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #minimo {
    margin: 0.4rem 0 0 0.5rem;
  }

  #maximo {
    margin: 0.4rem 0 0 -2rem;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
